import React from 'react';

export default field => {
    let focusColor = '#d7dde5';
    let borderRight;
    let borderBottom;
    let hoverColor;

    const isChecked =
        field.input.value === true ||
        field.input.value === 'true' ||
        field.input.value === 'on';

    if (isChecked) {
        focusColor = field.primaryColor ? field.primaryColor : '#00aae6';
        borderRight = field.primaryColor ? field.primaryColor : '#00aae6';
        borderBottom = field.primaryColor ? field.primaryColor : '#00aae6';
    } else if (field.hover[field.input.name])
        hoverColor = field.primaryColor ? field.primaryColor : '#00aae6';

    let color = focusColor;
    if (!isChecked && field.hover[field.input.name]) color = hoverColor;

    return (
        <div className={field.className}>
            <input
                {...field.input}
                type={field.type}
                name={field.input.name}
                className={field.className}
                checked={isChecked}
                onChange={field.input.onChange}
                style={{ border: '1px solid ' + color }}
                onMouseOver={e => {
                    e.preventDefault();
                    field.toggleHover(field.input.name);
                }}
                onMouseOut={e => {
                    e.preventDefault();
                    field.toggleHover(field.input.name);
                }}
            />
            <span
                className={isChecked ? 'checked' : 'unchecked'}
                style={{
                    borderRight: '1px solid ' + borderRight,
                    borderBottom: '1px solid ' + borderBottom,
                }}
            />
            {field.label.includes('<') && field.label.includes('>') ? (
                <label
                    className={'checklink ' + field.labelClass}
                    dangerouslySetInnerHTML={{ __html: ' ' + field.label }}
                    htmlFor={field.fieldKey}
                /> //TODO: eww..
            ) : (
                <label className={field.labelClass} htmlFor={field.fieldKey}>
                    {field.label}
                </label>
            )}
            {field.meta.touched && field.meta.error && !field.meta.active ? (
                <p className="validation-error">{field.meta.error}</p>
            ) : (
                ''
            )}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/CheckboxInput.js